import { PublicApi } from "api/api";

const publicApi = new PublicApi();

let languagesCache = null;
/** Single in-flight request so parallel callers (NavMenu + ensurePublicLanguageId) share one HTTP call. */
let languagesFetchPromise = null;

/** Clear cache if language list can change (optional). */
export function invalidatePublicLanguagesCache() {
  languagesCache = null;
  languagesFetchPromise = null;
}

export async function getPublicLanguages() {
  if (languagesCache) return languagesCache;
  if (!languagesFetchPromise) {
    languagesFetchPromise = publicApi
      .apiPublicLanguagesGet()
      .then(({ data }) => {
        languagesCache = Array.isArray(data) ? data : [];
        return languagesCache;
      })
      .catch(() => {
        languagesCache = [];
        return languagesCache;
      })
      .finally(() => {
        languagesFetchPromise = null;
      });
  }
  return languagesFetchPromise;
}

function matchLanguageEntry(languages, code) {
  if (!code || !languages?.length) return null;
  const lower = code.toLowerCase();
  const exact = languages.find(
    (l) => (l.i18nCode?.code || "").toLowerCase() === lower
  );
  if (exact) return exact;
  const base = lower.split("-")[0];
  return languages.find(
    (l) =>
      (l.i18nCode?.code || "").split("-")[0].toLowerCase() === base
  );
}

/**
 * Maps i18n codes (en, sr, en-US, …) to the server's language GUID.
 * Public APIs expect `LanguageId` / `i18nextLanguageId`, not locale strings.
 */
export async function ensurePublicLanguageId(languageCode) {
  const code =
    languageCode ||
    (typeof localStorage !== "undefined" &&
      localStorage.getItem("i18nextLng")) ||
    "en";

  const langs = await getPublicLanguages();
  const entry = matchLanguageEntry(langs, code);
  if (entry?.id) {
    localStorage.setItem("i18nextLanguageId", entry.id);
    if (entry.i18nCode?.code) {
      localStorage.setItem("i18nextLng", entry.i18nCode.code);
    }
    return entry.id;
  }

  return typeof localStorage !== "undefined"
    ? localStorage.getItem("i18nextLanguageId")
    : null;
}
